<template>
  <tr>
    <td class="flex justify-center whitespace-nowrap h-20">
      <Button type="button" color="blue" class="p-1 self-center w-8 h-8 rounded-lg"
        v-if="fileData.fileId && fileData.fileId !== ''"
        @click="$emit('deleteFile', fileData.fileId); $forceUpdate()"
        :disabled="actionDisabled"
      >
        <img src="@/assets/icons/Trash.svg"/>
      </Button>
      <Button type="button" color="blue" size="md" class="px-2 py-2 rounded-md !shadow self-center"
        v-else
        @click="$emit('showPicker', docType)"
        :disabled="actionDisabled">
        + Upload
      </Button>
    </td>
    <td class="px-2 py-2 whitespace-nowrap">
      {{ fileTypeOptions[docType] }}
    </td>
    <td class="px-2 py-2 whitespace-nowrap">
      <div class="text-sm text-gray-900">
        <a :href="fileLink" target="_blank" rel="noopener noreferrer">{{fileName}}</a>
      </div>
    </td>
    <td class="px-2 py-2 whitespace-nowrap">
      <a v-if="file.thumbnailLink" :href="fileLink" target="_blank" rel="noopener noreferrer">
        <img :src="file.thumbnailLink" referrerPolicy="no-referrer" class="h-20" />
      </a>
      <div v-else-if="fileData.fileId">
        Not yet available
      </div>
    </td>
    <td v-if="canValidate">
      <CalendarField
        v-model="fileData.expirationDate"
        @input="updateValue('expirationDate', fileData.expirationDate)"
        class="m-2">
      </CalendarField>
    </td>
  </tr>
</template>

<script>

import CalendarField from '../formComponents/CalendarField.vue'
import Button from '../Button.vue';

import DropdownLists from '../../components/DropdownLists.json'

export default {
  components: {
    CalendarField,
    Button,
  },
  props: {
    file: Object,
    docType: String,
    editable: Boolean,
    canValidate: Boolean,
  },
  data() {
    return {
      fileTypeOptions: DropdownLists.DocumentTypesList,
      fileData: {},
    }
  },
  methods: {
    updateValue(key, value) {
      this.$set(this.fileData, key, value)
      this.$emit('input', { ...this.fileData, [key]: value })
    },
    setDefault(){
      this.fileData = {...this.fileData, ...this.file}
      if(this.file.name){
        this.fileData.fileName = this.file.name
      }
      if(this.file.expiration_date){
        this.fileData.expirationDate = this.file.expiration_date
      }
      if(this.file.type){
        this.fileData.fileType = this.file.type
      }
      if(this.file.file_id){
        this.fileData.fileId = this.file.file_id
      }
    },
  },
  computed: {
    fileName() {
      if (! this.fileData.fileId) {
        return ""
      }
      if (! this.fileData.fileName) {
        return "File Name Unavailable"
      }
      return this.fileData.fileName
    },
    fileLink() {
      return `https://drive.google.com/open?id=${this.fileData.fileId}`
    },
    actionDisabled() {
      return !this.editable
    }
  },
  created() {
    this.setDefault()
  },
  watch: {
    file() {
      this.setDefault()
    },
    'file.fileId'() {
      this.setDefault()
    },
    'file.file_id'(){
      this.setDefault()
    }
  },
}
</script>